// extracted by mini-css-extract-plugin
module.exports = {"category":"style_category__k6rYi","active":"style_active__Q8EUo"};